<ng-container *ngIf="newsFilter && newsFilter.length > 0">
  <div class="news-panel__content">
    <h2 class="news-panel__title">{{ title }}</h2>

    <ngx-slick-carousel
      class="view view-news-related view-id-news_related view-display-id-news_related_pane view--news-related-slide"
      [config]="slideConfig"
      #slickModal="slick-carousel"
    >
      <div ngxSlickItem *ngFor="let new of newsFilter" class="views-row views-row-4 views-row-even slick-slide slick-active">
        <app-news-component [new]="new"></app-news-component>
      </div>
    </ngx-slick-carousel>
  </div>
</ng-container>
